import React from 'react';
import { createURL } from '@sm/utils';
import { Grid, Row, Col, Tabs, Tab } from '@sm/wds-react';

const ROUTE_CONFIG = {
  individualPricingPage: {
    path: '/pricing/individual/',
    title: 'Individual Plans',
    selected: false,
    queryString: {
      ut_source: 'pricing-summary'
    }
  },
  teamsPricingPage: {
    path: '/pricing/teams/',
    title: 'Team Plans',
    selected: true,
    queryString: {
      ut_source: 'pricing-summary'
    }
  }
};

const handlePricingNavChange = currentRoute => {
  window.location.assign(
    createURL(currentRoute.path, currentRoute.queryString)
  );
};

/**
 * @desc The main Navigation between individual and teams plans
 *
 */
const PricingNavigation = () => {
  return (
    <Grid>
      <Row>
        <Col xs={3} />
        <Col xs={6}>
          <Tabs
            onChange={(idx, route) => {
              handlePricingNavChange(ROUTE_CONFIG[route]);
            }}
            color="transparent"
            align="even"
          >
            {Object.keys(ROUTE_CONFIG).map(route => {
              const { title, selected } = ROUTE_CONFIG[route];
              return (
                <Tab id={route} key={route} title={title} selected={selected} />
              );
            })}
          </Tabs>
        </Col>
        <Col xs={3} />
      </Row>
    </Grid>
  );
};

export default PricingNavigation;
